import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import { getTemplate } from 'helpers/template-helper'
import { getDatesIntervalText } from 'helpers/date-helpers'
import { numberWithoutZeroFraction } from 'helpers/number-helpers'
import { currentCurrency } from 'init/current-currency'
import { jsonFeatures } from 'init/json-features'
import Backbone from 'init/backbone'
import { ItemDeliveryCollection } from 'es6/collections/item-delivery-collection'

@Defaults({
  deliveryPlaceholderClass: '.js-delivery-placeholder',
  deliveryTemplateId: '#item-delivery-template',
  priceTemplateId: '#delivery-price',
  additionalOptions: ['itemsCollection'],
})
export class DynamicItemDeliveryView extends View {
  /** @inheritDoc */
  run () {
    this.collection = new ItemDeliveryCollection([], {
      settlement: this.settlement,
    })
    if (this.cart) {
      this.listenTo(this.cart, 'sync', this.initItems)
    } else {
      this.listenTo(Backbone, 'update-cart-item', this.initItems)
      this.listenTo(Backbone, 'item-replaced-by-modifier', this.handleChangeModifier)
    }
    this.deliveryTemplate = getTemplate(this.deliveryTemplateId)
    this.priceTemplate = getTemplate(this.priceTemplateId)
    this.listenTo(this.collection, 'reset', this.renderItemDelivery)
  }

  /**
   * Выполняется при смене модификатора товара.
   * @param {number} replacedItemId Идентификатор товара замененного модификатором.
   * @param  {Model} modifierModel Модель модификатора.
   */
  handleChangeModifier (replacedItemId, modifierModel) {
    this.collection.setAppliedModifier(String(replacedItemId), String(modifierModel.id))
    this.initItems({ modifierModel: modifierModel })
  }

  /**
   * Инициализация товаров для запроса и рендера дат доставки.
   * @param {Object} [option] Опции.
   * @param {boolean} option.isItemsRender Признак что метод вызван после рендера товаров.
   * @param {Model} option.modifierModel Модель модификатора.
   */
  initItems (option) {
    if (this.cart || this.itemsCollection.viewtype === 'list') {
      this.deliveryPlaceholders = this.initItemsPlaceholders()
      let itemModels = option?.modifierModel
        ? [option.modifierModel]
        : this.itemsCollection.models
      if (option?.isItemsRender && this.itemsCollection.fetchCounter !== 1
        && this.itemsCollection.mode === 'infinite') {
        itemModels = itemModels.slice(-this.itemsCollection.state.itemsInResponse)
      }
      const itemsRequestIds = itemModels.filter(model => {
        return !model.has('is_balanced') || model.get('is_balanced')
      }).map(model => {
        return model.id
      })
      if (itemsRequestIds.length) {
        this.collection.requestItemDelivery(itemsRequestIds)
      }
    }
  }

  /**
   * Инициализация плейсхолдеров товаров на странице.
   * @returns {Array} Плейсхолдеры для рендера данных доставки.
   */
  initItemsPlaceholders () {
    const result = []
    this.$el.find(this.deliveryPlaceholderClass).each((index, placeholder) => {
      const $placeholder = $(placeholder),
        id = $placeholder.data('id')
      if (id) {
        result.push({ id: id, placeholder: $placeholder })
      }
    })
    return result
  }

  /**
   * Рендер доставки товара.
   * @param {ItemDeliveryCollection} collection Коллекция.
   */
  renderItemDelivery (collection) {
    this.deliveryPlaceholders.forEach(itemPlaceholder => {
      let model = collection.find({ id: itemPlaceholder.id })
      if (model) {
        model = model.toJSON()
        if (model.min_date || model.cost) {
          const dateTextArray = getDatesIntervalText(model.min_date, model.max_date).split(' - ')
          itemPlaceholder.placeholder.html(this.deliveryTemplate({
            ...model,
            dateText: dateTextArray,
            costTemplate: this.getPriceTemplate(model.cost),
            itemCostTemplate: this.getItemPriceTemplate(model.item_cost),
            minQtyItemCostTemplate: this.getItemPriceTemplate(
              jsonFeatures.is_retail_fees_enabled
                ? model.min_qty_item_cost / model.min_qty
                : model.min_qty_item_cost
            ),
          }))
        }
      }
    })
  }

  /**
   * Возвращает шаблон цены с определённой суммой.
   * @param {number} priceValue Стоимость.
   * @returns {string} Шаблон цены с определённой суммой.
   */
  getPriceTemplate (priceValue) {
    const priceFraction = numberWithoutZeroFraction(priceValue)
    return this.priceTemplate({
      priceFraction,
      currency: currentCurrency.sign,
    })
  }

  /**
   * Возвращает шаблон цены с определённой суммой для одного товара.
   * @param {number} itemPriceValue Стоимость.
   * @returns {string} Шаблон цены с определённой суммой для одного товара.
   */
  getItemPriceTemplate (itemPriceValue) {
    if (typeof itemPriceValue !== 'number') {
      return ''
    }
    return this.getPriceTemplate(itemPriceValue)
  }
}
